import { SearchBar, Switch, Toast } from "antd-mobile";
import styles from "./index.module.scss";
import { useContext, useState } from "react";
import { NavListContext } from "App";
import { useNavigate } from "react-router-dom";
import { AiOutlineSearch } from "react-icons/ai";

const SearchArea = (data: {
  showSwitch: boolean;
  onHover: (onHover) => void;
}) => {
  const [searchAllCategory, toggleSearchAllCategory] = useState(false);
  const navList = useContext(NavListContext).navList;
  const updateNavList = useContext(NavListContext).updateNavList;
  const navigate = useNavigate();
  return (
    <>
      <div className=" m-2 flex gap-2">
        {data.showSwitch && (
          <>
            <Switch
              checked={searchAllCategory}
              defaultChecked={false}
              className={styles.mystyle}
              uncheckedText="当前分区"
              checkedText="所有资源"
              style={{
                "--checked-color": "#FB923C",
              }}
              onChange={() => {
                toggleSearchAllCategory(!searchAllCategory);
              }}
            />
          </>
        )}
        <div className=" grow text-nowrap">
          <SearchBar
            icon={<AiOutlineSearch size={20} color="orange" />}
            placeholder="别在海洋作浪, 搜索一下来得更快"
            showCancelButton={false}
            maxLength={20}
            onFocus={() => {
              data.onHover(true);
            }}
            onBlur={() => {
              data.onHover(false);
            }}
            onCancel={()=>{
              data.onHover(false);
            }}
            onSearch={(searchKeyword) => {
              // Toast.show(
              //   "搜索类型: " +
              //     (searchAllCategory ? "所有资源" : "当前分区") +
              //     ", 搜索分类:" +
              //     (navList.top2TermNow?.termName || navList.top1TermNow?.termName || navList.btmTermNow?.termName) +
              //     `, 搜索资源：${searchKeyword}`
              // );
              navigate("/search", {
                state: {
                  searchAllCategory: searchAllCategory,
                  searchKeyword: searchKeyword,
                  searchCategoryId: searchAllCategory
                    ? null
                    : navList.top2TermNow?.termUuid ||
                      navList.top1TermNow?.termUuid ||
                      navList.btmTermNow?.termUuid,
                  searchCategory: searchAllCategory
                    ? "所有资源"
                    : navList.top2TermNow?.termName ||
                      navList.top1TermNow?.termName ||
                      navList.btmTermNow?.termName,
                  searchCategoryUrl: searchAllCategory,
                },
              });
            }}
            className={[" tracking-widest text-sm", styles.mystyle].join(" ")}
            style={{
              "--border-radius": "8px",
              "--background": "#ddd",
              "--padding-left": "5px",
              "--placeholder-color": "#666",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default SearchArea;
